import Vue from 'vue';

export const MatchPickerField = Vue.component(
    'MatchPickerField',
    require('~/components/FieldTypes/MatchPicker/MatchPicker.vue').default
);
